function updateURLParameter(key, value) {
  var url = new URL(window.location.href);
  if (url.searchParams.has(key)) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.append(key, value);
  }
  window.history.pushState({}, '', url);
  window.location.href = url.toString();
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    var selects = document.querySelectorAll(".products-per-page__select");
    selects.forEach(select => select.addEventListener("change", this.debouncedOnSubmit.bind(this)));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    
    // Add event listener for page load to handle tags with quotes
    window.addEventListener('load', () => {
      // Get all checkboxes with tag values
      const tagCheckboxes = document.querySelectorAll('input[type="checkbox"][name^="tag-"]');
      
      // Get current tags from URL
      const url = new URL(window.location.href);
      const pathParts = url.pathname.split('/');
      const tagsPart = pathParts.find(part => part.includes('+'));
      
      if (tagsPart) {
        // Split by + and decode each part
        const urlTags = tagsPart.split('+').map(tag => decodeURIComponent(tag));
        
        // Check each checkbox if its value matches a current tag
        tagCheckboxes.forEach(checkbox => {
          const checkboxValue = decodeURIComponent(checkbox.value);
          
          // Check if the checkbox value is contained in any of the URL tags
          // This handles cases like size_24+16+manual where we need to match size_24
          const isChecked = urlTags.some(urlTag => {
            // Check for exact match
            if (urlTag === checkboxValue) return true;
            
            // Check if the checkbox value is a prefix of the URL tag
            // This handles cases like size_24 in size_24+16+manual
            if (urlTag.startsWith(checkboxValue + '+')) return true;
            
            // Check if the checkbox value is part of the URL tag
            // This handles cases where the tag might be in a different format
            if (urlTag.includes(checkboxValue)) return true;
            
            return false;
          });
          
          if (isChecked) {
            checkbox.checked = true;
          }
        });
      }
    });
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static async renderPage(searchParams, event, updateURLHash = true, tags) {

    if(event && event.target && event.target.classList.contains('products-per-page__select')){
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, tags);

      await this.selectUpdate(event.target.value);
      return;
    }

    // Decode tags if they contain quotes
    if (tags && tags.length > 0) {
      tags = tags.map(tag => decodeURIComponent(tag));
      
      // Process tags that might contain multiple values combined with +
      const processedTags = [];
      tags.forEach(tag => {
        if (tag.includes('+')) {
          // Split by + and add each part as a separate tag
          const tagParts = tag.split('+');
          tagParts.forEach(part => {
            if (part && !processedTags.includes(part)) {
              processedTags.push(part);
            }
          });
        } else {
          processedTags.push(tag);
        }
      });
      tags = processedTags;
    }

    // FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {

      const tagsString = tags.length > 0 ? '/' + tags.join('+') : '';
      const url = `${window.routes.current_collection}${tagsString}?section_id=${section.section}&${searchParams}`;

      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    this.getFilterSentence(searchParams)

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, tags)

    const productCount = document.querySelector('.product-count-vertical h2');
    if(productCount) productCount.focus();

  }

  static async selectUpdate(value) {
    window.scrollTo(0, 0);
    
    const body = JSON.stringify({ attributes: { 
      products_per_page: value
    } });
    await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then(async (response) => {
      console.log('response', response)
    })
    .catch((e) => {
      console.error(e);
    });

    window.location.reload();
  }

  static getFilterSentence(queryString){

    const queryParams = queryString.split('&');

    // Initialize variables for filter and sort
    let filterValues = '';
    let sortBy = '';

    // Parse each parameter
    for (const param of queryParams) {
        if (param.startsWith('filter')) {
            // Extract filter values
            filterValues += param.split('=')[1].replace(/\+/g, ' ') + ', '; // Replace '+' with space
        } else if (param.startsWith('sort_by')) {
            // Extract sort by value
            sortBy = param.split('=')[1];
        }
    }

    // Construct sentences
    let filterSentence = "Filter: " + filterValues.replace(/,\s*$/, '');
    let filterSentence_sorted = 'Sorted By: ' + sortBy;

    const span = document.createElement('span');
    span.classList.add('alert', 'danger', 'small');
    span.innerText = filterSentence;

    const span_2 = document.createElement('span');
    span_2.classList.add('alert', 'danger', 'small');
    span_2.innerText = filterSentence_sorted;

    document.querySelector('.facet-alert-container').innerHTML = ''
    document.querySelector('.facet-alert-container').appendChild(span)
    document.querySelector('.facet-alert-container').appendChild(span_2)

  }

  static renderSectionFromFetch(url, event) {
    console.log('url', url)

    // Check if this is a search request
    const isSearchRequest = url.includes('q=') || window.location.pathname.includes('/search');
    
    // If it's a search request, ensure the URL starts with /search
    if (isSearchRequest) {
      const urlObj = new URL(url);
      const searchParams = urlObj.searchParams.toString();
      url = `/search?${searchParams}`;
    }

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
        // Re-check checkboxes based on current URL tags
        const currentUrl = new URL(window.location.href);
        const pathParts = currentUrl.pathname.split('/');
        const tagsPart = pathParts.find(part => part.includes('+'));
        
        if (tagsPart) {
          // Split by + and decode each part
          const urlTags = tagsPart.split('+').map(tag => decodeURIComponent(tag));
          
          // Get all checkboxes with tag values
          const tagCheckboxes = document.querySelectorAll('input[type="checkbox"][name^="tag-"]');
          
          // Check each checkbox if its value matches a current tag
          tagCheckboxes.forEach(checkbox => {
            const checkboxValue = decodeURIComponent(checkbox.value);
            
            // Check if the checkbox value is contained in any of the URL tags
            const isChecked = urlTags.some(urlTag => {
              // Check for exact match
              if (urlTag === checkboxValue) return true;
              
              // Check if the checkbox value is a prefix of the URL tag
              if (urlTag.startsWith(checkboxValue + '+')) return true;
              
              // Check if the checkbox value is part of the URL tag
              if (urlTag.includes(checkboxValue)) return true;
              
              return false;
            });
            
            checkbox.checked = isChecked;
          });
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

      // Scroll the body to the ProductGridContainer
      const headerHeight = document.querySelector('header').offsetHeight;
      const ProductGridContainer = document.getElementById('ProductGridContainer');
      const firstProduct = document.querySelector('.product-count-vertical h2');
      
      if(ProductGridContainer){
        window.scroll({
          top: ProductGridContainer.offsetTop - headerHeight - 32,
          behavior: 'smooth'
        });

        if(firstProduct) firstProduct.focus();
      }
     
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        // const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        // if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams, tags) {
    // Log the tags being added to the URL for debugging
    console.log('Tags being added to URL:', tags);
    console.log('Raw search params:', searchParams);
    
    // Filter out any non-tag values that might have been incorrectly added
    const filteredTags = tags.filter(tag => {
      // Check if the tag is a valid product tag (contains an underscore)
      const isValid = tag.includes('_');
      if (!isValid) {
        console.log('Invalid tag found:', tag);
        console.log('Tag source:', new Error().stack);
      }
      return isValid;
    });
    
    console.log('Filtered tags:', filteredTags);
    
    const tagsString = filteredTags.length > 0 ? '/' + filteredTags.join('+') : '';
    
    // Check if current URL contains /search
    const currentUrl = window.location.href;
    const isSearchPage = currentUrl.includes('/search');
    
    // Get the base URL
    let baseUrl;
    if (isSearchPage) {
      // For search pages, use the search URL structure
      baseUrl = '/search';
      
      // Preserve search-specific parameters
      const searchParamsObj = new URLSearchParams(searchParams);
      const currentParams = new URLSearchParams(window.location.search);
      
      // Preserve q, options[prefix], and type parameters if they exist
      ['q', 'options[prefix]', 'type'].forEach(param => {
        if (currentParams.has(param) && !searchParamsObj.has(param)) {
          searchParamsObj.append(param, currentParams.get(param));
        }
      });
      
      searchParams = searchParamsObj.toString();
    } else {
      baseUrl = window.routes.current_collection;
    }
    
    const url = `${baseUrl}${tagsString}${searchParams && '?'.concat(searchParams)}`;
    history.pushState({ searchParams }, '', url);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event, tags) {
    FacetFiltersForm.renderPage(searchParams, event, true, tags);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const group = event.target.closest('.facets-layout-list');

    if(group){
      group.querySelectorAll('input').forEach(input => {
        if(input !== event.target) input.checked = false;
      });
    }
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      console.log('Mobile form submitted with params:', searchParams);
      this.onSubmitForm(searchParams, event);
    } else {
      let forms = [];
      const tags = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form, index) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            const formParams = this.createSearchParams(form);
            console.log('Desktop form params:', formParams);
            forms.push(formParams);
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          const formParams = this.createSearchParams(form);
          console.log('Mobile form params:', formParams);
          forms.push(formParams);
        }
      });

      console.log('Forms being processed:', forms);

      if (!isMobile) {
        var products_per_page = document.querySelector('.products-per-page select');
        if(products_per_page) {
          const ppValue = 'products_per_page=' + products_per_page.value;
          console.log('Adding products per page:', ppValue);
          forms.push(ppValue);
        }
        
        forms.forEach((form, index) => {
          console.log('Processing form:', form);
          if (form.includes('tag-')) {
            var tags_array = form.split('&');
            console.log('Tags array from form:', tags_array);
            tags_array.forEach((tag) => {
              const [tagName, tagValue] = tag.split('=');
              console.log('Processing tag:', {name: tagName, value: tagValue});
              // Decode the tag value to handle quotes properly
              const decodedValue = decodeURIComponent(tagValue);
              console.log('Decoded tag value:', decodedValue);
              if (!decodedValue.includes('_')) {
                console.log('Warning: Invalid tag format detected:', decodedValue);
                console.log('From form:', form);
                console.log('Original tag:', tag);
              }
              tags.push(decodedValue);
            })
            forms.splice(index, 1);
          }
        });
      } else {
        // Add products_per_page parameter for mobile just like desktop
        var products_per_page = document.querySelector('.products-per-page select');
        if(products_per_page) {
          const ppValue = 'products_per_page=' + products_per_page.value;
          console.log('Adding products per page (mobile):', ppValue);
          forms.push(ppValue);
        }
        
        // Process forms the same way as desktop
        forms.forEach((form, index) => {
          console.log('Processing mobile form:', form);
          if (form.includes('tag-')) {
            var tags_array = form.split('&');
            console.log('Mobile tags array:', tags_array);
            tags_array.forEach((tag) => {
              const [tagName, tagValue] = tag.split('=');
              console.log('Processing mobile tag:', {name: tagName, value: tagValue});
              // Decode the tag value to handle quotes properly
              const decodedValue = decodeURIComponent(tagValue);
              console.log('Decoded mobile tag value:', decodedValue);
              if (!decodedValue.includes('_')) {
                console.log('Warning: Invalid mobile tag format detected:', decodedValue);
                console.log('From mobile form:', form);
                console.log('Original mobile tag:', tag);
              }
              tags.push(decodedValue);
            })
            forms.splice(index, 1);
          }
        });
      }

      this.onSubmitForm(forms.join('&'), event, tags);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input[type="number"]').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.querySelectorAll('input[type="radio"]').forEach((element) =>
      element.addEventListener('change', this.radioRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  radioRangeChange(event) {

    const selectedRadio = event.target;
    const value = selectedRadio.value;
    const [minValue, maxValue] = value.split('-');

    const inputs = this.querySelectorAll('input[type="number"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    minInput.value = minValue;
    maxInput.value = maxValue;

    this.setMinAndMaxValues();

  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type="number"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
